import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { PanelUserDropdown } from "@components/navbar-common";
import useActiveNav from "@layouts/hooks/use-active-nav";
import BrandSwitcher from "./brand-switcher";
import PaymentModelToggle from "./payment-model-toggle";
import PublisherSwitcher from "./publisher-switcher";

const Topbar = ({ menuData }) => {
  const { label, homeLink, title } = useActiveNav(menuData);

  return (
    <header className="sticky top-0 z-[150] flex h-16 items-center justify-between border-b border-gray-200 bg-white px-6">
      <nav className="flex items-center gap-1.5 text-sm">
        {label && (
          <>
            <Link to={homeLink} className="text-muted hover:text-gray-700">
              {label}
            </Link>
            <ChevronRight className="h-3.5 w-3.5 text-gray-300" />
          </>
        )}
        <span className="font-medium text-gray-900">{title}</span>
      </nav>

      <div className="flex items-center gap-3">
        <PaymentModelToggle />
        <BrandSwitcher />
        <PublisherSwitcher />
        <PanelUserDropdown />
      </div>
    </header>
  );
};

Topbar.propTypes = {
  menuData: PropTypes.shape({
    panel: PropTypes.array,
    label: PropTypes.string
  })
};

export default Topbar;
